/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'poll': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="1" d="M13 7.5h5v2h-5zm0 7h5v2h-5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM11 6H6v5h5V6zm-1 4H7V7h3v3zm1 3H6v5h5v-5zm-1 4H7v-3h3v3z"/>'
  }
})
